import React from 'react';
import { useDispatch } from 'react-redux';
import {
  Divider,
  Grid,
  TextField,
  Typography,
  Switch
} from '@material-ui/core';
import { changeHomepagePremiumCTAConfig } from 'redux/actions/store_configs';


const PremiumCTAGeneral = ({values, setFieldValue}) => {
  const dispatch = useDispatch();
  const { general } = values;

  const handleChange = (event) => {
    const {name, checked, type, value} = event.target;
    dispatch(changeHomepagePremiumCTAConfig(name, checked, type, value));

    if (type === 'checkbox') {
      setFieldValue(`general[${name}]`, checked ? '1' : '0');
    }

    if (type === 'text') {
      setFieldValue(`general[${name}]`, value);
    }
  };

  return (
    <div>
      <Typography variant="h4" className="my-6 mx-3">General</Typography>
      <Divider className="mb-8" />
      <Grid container spacing={3} className="mb-4">
        <Grid item xs={12} sm={2} className="my-2 ml-4">Enable</Grid>
        <Grid item xs={12} sm={9}>
          <Switch
            color="primary"
            name={'store_info/premium_plus_cta/is_premium_plus_cta_enable'}
            checked={general['store_info/premium_plus_cta/is_premium_plus_cta_enable'] == 1}
            onChange={handleChange}
          />
        </Grid>
        <Grid item xs={12} sm={2} className="my-2 ml-4">Main Title</Grid>
        <Grid item xs={12} sm={9}>
          <TextField
            fullWidth
            variant="outlined"
            name={'store_info/premium_plus_cta/premium_plus_cta_main_title'}
            label="Title"
            value={general['store_info/premium_plus_cta/premium_plus_cta_main_title']}
            onChange={handleChange}
            inputProps={{
              shrink: 'true'
            }}
          />
        </Grid>
      </Grid>
    </div>
  );
};

export default PremiumCTAGeneral;
